import { Fragment } from "react";
import Icon from "../../../Icon/Icon";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import setFileData from '../utils';
import { UTCHint } from "../../../MainComponents";
import { useTranslation } from "react-i18next";
import CustomPaginate from "./CustomPaginate/CustomPaginate";
import "./ReportsTable.scss";

const ReportsTable = ({
  reports,
  selectedFile,
  setSelectedFile,
  setShowDetailFileModal,
  downloadFunction,
  metadata,
  updateFromPaginator,
}) => {
  const [t] = useTranslation("exports");
  const selectLabel = t("paginate.label");
  const translations = {
    nameFirst: t("exportablesTable.row.nameFirst"),
    nameSecond: t("exportablesTable.row.nameSecond"),
    days: t("exportablesTable.row.days"),
  };

  const getFile = (file) => (e) => {
    const isStatusCell = e.target.closest('.actions');

    setSelectedFile({...file});

    if (isStatusCell) {
      if (file.is_recent) {
        downloadFunction(file);
      }
    } else {
      setShowDetailFileModal(true);
    }
  };

  const paginateMessageGenerator = (paginatorContext) => {
    const { limits, listLength } = paginatorContext;

    return (
      <>
        <span>{t("paginate.results")}: {limits[0]} {t("paginate.to")} {limits[1]} {t("paginate.of")} {listLength}</span>
      </>
    );
  };

  const iconValid = <Icon color={'green'} width="36" height="36" name={'check_icon'} />;
  const iconNotValid = <Icon color={'red'} width="36" height="36" name={'close_icon'} />;
  const iconDownload = <Icon
    className={'actions'}
    color={'blue'}
    width="18"
    height="18"
    name={'outline_document_download'}
  />;

  return (
    <>
      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: '576px' }}>
          <TableHead className="table-head">
            <TableRow>
              <TableCell>{t("exportablesTable.file")}</TableCell>
              <TableCell>{t("exportablesTable.format")}</TableCell>
              <TableCell>{t("exportablesTable.status")}</TableCell>
              <TableCell className={"hidden-celd"}>{t("exportablesTable.date")}</TableCell>
              <TableCell className={"hidden-celd"}>{t("exportablesTable.expires")}</TableCell>
              <TableCell>{t("exportablesTable.actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(reports || []).map((report, index) => {
              const processedData = setFileData(report, translations);
              return (
                <Fragment key={index}>
                  <TableRow className="table-row" onClick={getFile(processedData)}>
                    <TableCell>{processedData.name}</TableCell>
                    <TableCell>{`${processedData.kind[0].toUpperCase()}${processedData.kind.slice(1)}` ?? 'Excel'}</TableCell>
                    <TableCell>{processedData.status ? iconValid : iconNotValid}</TableCell>
                    <TableCell className={"hidden-celd"}>
                      {processedData.created_at_label}
                      {report.created_at && <UTCHint date={report.created_at} />}
                    </TableCell>
                    <TableCell className={"hidden-celd"}>{processedData.expires}</TableCell>
                    <TableCell>
                      {iconDownload}
                    </TableCell>
                  </TableRow>
                </Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPaginate
        listLength={metadata?.count ?? 0}
        updateFromPaginator={updateFromPaginator}
        paginateMessageGenerator={paginateMessageGenerator}
        selectLabel={selectLabel}
        margins={{ x: '0', y: '2rem' }}
      />
      <div style={{ marginBottom: '480px' }}></div>
    </>
  );
};

export default ReportsTable;